module.exports = "<div class=\"breadcrumb\">\r\n  <div *ngFor=\"let item of items\">{{item}}</div>\r\n  <div (click)=\"clickStudentenOverzicht()\" class=\"students\">Studentenoverzicht</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.component.html
// module id = ./src/app/breadcrumb/breadcrumb.component.html
// module chunks = main